import { Component, EventEmitter, Input, Output } from "@angular/core";

import { ItemMessageStart, ItemMessageEnd } from "./item-message.model";

@Component({
  selector: 'lib-item-message',
  templateUrl: './item-message.component.html',
  styleUrls: ['./item-message.component.scss']
})
export class ItemMessageComponent {
  @Input() containerStyle: string = '';
  @Input() start: ItemMessageStart = {
    type: 'ionic-icon',
    icon: 'information-circle-outline',
    cssCustomClass: 'text-orange-500',
  };
  @Input() end?: ItemMessageEnd;

  @Output() startIconClick = new EventEmitter<void>();
  @Output() endIconClick = new EventEmitter<void>();
}
